import secureApi from "../services/secureApi";
// List
export const getProduct = async (
  page = page,
  limit = limit
) => {
  try {
    const response = await secureApi.get(
      `/admin/products/list?page=${page}&limit=${limit}`
    );

    return response.data;

  } catch (error) {
    console.error("Error fetching Product:", error);

    return {
      data: [],
      totalPages: 0,
      currentPage: 1,
      totalItems: 0,
    };
  }
};

// Add
export const addProduct = async (
  productData
) => {
  try {
    const response =
      await secureApi.post(
        "/admin/products/add",
        productData
      );

    return response.data;

  } catch (error) {
    console.log(
      "ADD PRODUCT ERROR",
      error
    );

    throw error;
  }
};
// Edit
export const editProduct = async (id, payload) => {
  try {
    const response = await secureApi.put(`/admin-upload/products/edit/${id}`, payload);

    return response.data;
  } catch (error) {
    console.error("Edit Product API Error:", error);
    throw error;
  }
};

//view
export const getProductBySlug = async (slug) => {
  try {
    const response = await secureApi.get(`/admin/products/view/${slug}`);
    return response.data;
  } catch (error) {
    console.error("Get Admin Product By Slug API Error:", error);
    throw error;
  }
};

/* ================= DELETE PRODUCT ================= */

export const deleteProduct = async (id) => {
  try {
    const response = await secureApi.delete(`/admin/products/delete/${id}`);

    return response.data;
  } catch (error) {
    throw error;
  }
};

// AddImages
export const addProductImages =
  async (data) => {
    try {
      const response =
        await secureApi.post(
          "/admin-upload/products/addImages",
          data,
        );

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  export const exportProducts = async () => {
  const response = await secureApi.get(
    "/admin/products/export",
    {
      responseType: "blob",
    }
  );

  return response;
};

